(function () {
  var section = document.querySelector("[data-bundle]");
  if (!section) return;

  document.body.classList.add("bundle-page");

  var TIERS = [];
  try {
    TIERS = JSON.parse(section.getAttribute("data-tiers") || "[]");
  } catch (e) {
    TIERS = [
      { qty: 3, discount: 15 },
      { qty: 4, discount: 20 },
      { qty: 5, discount: 25 },
    ];
  }

  TIERS.sort(function (a, b) {
    return a.qty - b.qty;
  });

  var MAX_QTY = parseInt(section.getAttribute("data-max-qty"), 10) || 5;
  var MIN_QTY = parseInt(section.getAttribute("data-min-qty"), 10) || 3;
  var VISIBLE_CATEGORIES = parseInt(section.getAttribute("data-visible-categories"), 10) || 4;
  var MONEY_FORMAT = section.getAttribute("data-money-format") || "${{amount}}";
  var CART_URL = section.getAttribute("data-cart-url") || "/cart/add";

  var tabs = section.querySelectorAll("[data-bundle-tab]");
  var firstTab = tabs.length ? tabs[0].getAttribute("data-bundle-tab") : "";

  var state = {
    tab: section.getAttribute("data-active-tab") || firstTab || "",
    selected: [],
    expanded: false,
    loading: false,
  };

  var PRODUCTS = {};

  section.querySelectorAll("[data-bundle-product]").forEach(function (card) {
    var id = card.getAttribute("data-bundle-product");
    if (!id) return;

    if (!PRODUCTS[id]) {
      PRODUCTS[id] = {
        id: id,
        variantId: card.getAttribute("data-variant-id"),
        name: card.getAttribute("data-product-name") || "",
        price: parseInt(card.getAttribute("data-product-price"), 10) || 0,
        available: !card.hasAttribute("data-unavailable"),
        cards: [],
      };
    }

    PRODUCTS[id].cards.push(card);
    if (!PRODUCTS[id].available && !card.hasAttribute("data-unavailable")) {
      PRODUCTS[id].available = true;
    }
  });

  var catalogEl = section.querySelector("[data-bundle-catalog]");
  var tierPanels = section.querySelectorAll("[data-bundle-tier]");
  var progressFill = section.querySelector("[data-bundle-progress-fill]");
  var progressThumb = section.querySelector("[data-bundle-progress-thumb]");
  var progressCount = section.querySelector("[data-bundle-progress-count]");
  var progressUnlock = section.querySelector("[data-bundle-progress-unlock]");
  var moreBtn = section.querySelector("[data-bundle-more]");
  var moreWrap = section.querySelector("[data-bundle-more-wrap]");
  var selectedList = section.querySelector("[data-bundle-selected]");
  var subtotalEl = section.querySelector("[data-bundle-subtotal]");
  var discountEl = section.querySelector("[data-bundle-discount]");
  var totalEl = section.querySelector("[data-bundle-total]");
  var shippingEl = section.querySelector("[data-bundle-shipping]");
  var ctaBtns = section.querySelectorAll("[data-bundle-cta]");
  var barCount = section.querySelector("[data-bundle-bar-count]");
  var barUnlock = section.querySelector("[data-bundle-bar-unlock]");
  var barFill = section.querySelector("[data-bundle-bar-fill]");
  var barTruck = section.querySelector("[data-bundle-bar-truck]");
  var barSteps = section.querySelectorAll("[data-bundle-bar-step]");
  var shippingCents = null;
  var shippingLoaded = false;

  function formatMoney(cents) {
    var amount = (Math.max(cents, 0) / 100).toFixed(2);
    var amountNoDecimals = String(Math.round(Math.max(cents, 0) / 100));
    var amountWithComma = amount.replace(".", ",");
    var formatted = "";

    if (window.Shopify && typeof Shopify.formatMoney === "function") {
      formatted = Shopify.formatMoney(cents, MONEY_FORMAT);
    } else {
      formatted = MONEY_FORMAT
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountWithComma)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
        .replace(/\{\{\s*amount\s*\}\}/g, amount);
    }

    // Shopify.formatMoney / money filter may return HTML like <span class="money">...</span>
    var tmp = document.createElement("div");
    tmp.innerHTML = formatted;
    return (tmp.textContent || tmp.innerText || "").trim() || "$" + amount;
  }

  function discountForCount(count) {
    var discount = 0;
    TIERS.forEach(function (tier) {
      if (count >= tier.qty) discount = tier.discount;
    });
    return discount;
  }

  function isSelected(id) {
    return state.selected.indexOf(id) !== -1;
  }

  function escapeHtml(text) {
    var el = document.createElement("span");
    el.textContent = text || "";
    return el.innerHTML;
  }

  function updateCards() {
    Object.keys(PRODUCTS).forEach(function (id) {
      var product = PRODUCTS[id];
      var active = isSelected(id);

      product.cards.forEach(function (card) {
        card.classList.toggle("is-added", active);

        if (card.hasAttribute("data-unavailable")) return;

        card.setAttribute("aria-pressed", active ? "true" : "false");
        card.setAttribute(
          "aria-label",
          (active ? "Remove " : "Add ") + (product.name || "") + (active ? " from bundle" : " to bundle")
        );

        var addEl = card.querySelector("[data-bundle-add]");
        if (addEl) {
          addEl.classList.toggle("is-added", active);
          var textEl = addEl.querySelector("[data-bundle-add-text]");
          if (textEl) textEl.textContent = active ? "In cart" : "Add to cart";
          var icon = addEl.querySelector("[data-bundle-add-icon]");
          if (icon) {
            var nextSrc = active
              ? icon.getAttribute("data-icon-added")
              : icon.getAttribute("data-icon-default");
            if (nextSrc) icon.src = nextSrc;
          }
        }
      });
    });
  }

  function getActiveCategories() {
    return Array.prototype.slice.call(
      section.querySelectorAll('[data-bundle-category-tab="' + state.tab + '"]')
    );
  }

  function updateCategories() {
    var allCategories = section.querySelectorAll("[data-bundle-category]");
    var activeCategories = getActiveCategories();

    allCategories.forEach(function (category) {
      var tabId = category.getAttribute("data-bundle-category-tab");
      var isActiveTab = tabId === state.tab;
      category.classList.toggle("is-tab-hidden", !isActiveTab);
    });

    activeCategories.forEach(function (category, index) {
      var collapsed = !state.expanded && index >= VISIBLE_CATEGORIES;
      category.classList.toggle("is-hidden", collapsed);
    });

    if (moreWrap) {
      moreWrap.hidden = activeCategories.length <= VISIBLE_CATEGORIES;
    }
    if (moreBtn) {
      moreBtn.setAttribute("aria-expanded", state.expanded ? "true" : "false");
      var label = moreBtn.querySelector("[data-bundle-more-label]");
      if (label) label.textContent = state.expanded ? "Show less" : "Show more";
      moreBtn.classList.toggle("is-open", state.expanded);
    }
  }

  function updateTabs() {
    tabs.forEach(function (btn) {
      var active = btn.getAttribute("data-bundle-tab") === state.tab;
      btn.classList.toggle("is-active", active);
      btn.setAttribute("aria-selected", active ? "true" : "false");
    });
    section.setAttribute("data-active-tab", state.tab);
  }

  function updateProgress() {
    var count = state.selected.length;
    var pct = Math.min((count / MAX_QTY) * 100, 100);
    var discount = discountForCount(count);

    if (progressCount) {
      progressCount.textContent = count + " item" + (count !== 1 ? "s" : "") + " selected";
    }
    if (progressUnlock) {
      if (discount > 0) {
        progressUnlock.textContent = discount + "% off unlocked";
      } else {
        progressUnlock.textContent = "Add " + MIN_QTY + "+ items to unlock discount";
      }
      progressUnlock.hidden = false;
      progressUnlock.classList.toggle("is-muted", discount === 0);
    }
    if (progressFill) progressFill.style.width = pct + "%";
    if (progressThumb) {
      var ratio = Math.min(count / MAX_QTY, 1);
      progressThumb.style.left = "calc((100% - 30px) * " + ratio + ")";
    }

    tierPanels.forEach(function (panel) {
      var qty = Number(panel.getAttribute("data-bundle-tier"));
      panel.classList.toggle("is-active", count >= qty);
    });

    updateBar(count, discount);
  }

  // Mobile card: markers sit at fixed points on the track (Figma), the fill moves between them.
  // Like the Figma, the truck sits half a step past the last item added so it never covers a marker.
  var BAR_POINTS = [0.219, 0.605, 0.991];

  function barRatio(count) {
    if (count <= 0) return 0;
    count += 0.5;
    var prevQty = 0;
    var prevPoint = 0;
    for (var i = 0; i < TIERS.length; i++) {
      var point = BAR_POINTS[i] !== undefined ? BAR_POINTS[i] : 1;
      if (count <= TIERS[i].qty) {
        var span = TIERS[i].qty - prevQty;
        return prevPoint + (span > 0 ? (count - prevQty) / span : 1) * (point - prevPoint);
      }
      prevQty = TIERS[i].qty;
      prevPoint = point;
    }
    return prevPoint;
  }

  function updateBar(count, discount) {
    var next = null;
    for (var i = 0; i < TIERS.length; i++) {
      if (count < TIERS[i].qty) {
        next = TIERS[i];
        break;
      }
    }

    if (barCount) barCount.textContent = count + "/" + (next ? next.qty : MAX_QTY) + " items";
    if (barUnlock) {
      barUnlock.textContent = next
        ? next.qty - count + " more to unlock " + next.discount + "% off"
        : discount + "% off unlocked";
    }

    var ratio = barRatio(count);
    if (barFill) barFill.style.width = ratio * 100 + "%";
    if (barTruck) barTruck.style.left = "max(0px, calc((100% - 19px) * " + ratio + " - 15px))";

    barSteps.forEach(function (step) {
      step.classList.toggle("is-reached", count >= Number(step.getAttribute("data-bundle-bar-step")));
    });
  }

  function updateSidebar() {
    var items = state.selected
      .map(function (id) {
        return PRODUCTS[id];
      })
      .filter(Boolean);

    var subtotal = items.reduce(function (sum, item) {
      return sum + item.price;
    }, 0);
    var discountPct = discountForCount(items.length);
    var discountValue = Math.round((subtotal * discountPct) / 100);
    var productTotal = Math.max(subtotal - discountValue, 0);
    var shippingCost = shippingCents === null ? 0 : shippingCents;
    var total = productTotal + shippingCost;

    if (selectedList) {
      if (!items.length) {
        selectedList.innerHTML = '<p class="bundle__empty">No products selected yet</p>';
      } else {
        selectedList.innerHTML = items
          .map(function (item) {
            return (
              '<div class="bundle__selected-row">' +
              '<p class="bundle__selected-name">' +
              escapeHtml(item.name) +
              "</p>" +
              '<span class="bundle__selected-price">' +
              formatMoney(item.price) +
              "</span>" +
              "</div>"
            );
          })
          .join("");
      }
    }

    if (shippingEl) {
      if (!shippingLoaded) {
        shippingEl.textContent = "Calculating…";
      } else if (shippingCents === null) {
        shippingEl.textContent = "At checkout";
      } else {
        shippingEl.textContent = formatMoney(shippingCents);
      }
    }

    if (subtotalEl) subtotalEl.textContent = formatMoney(subtotal);
    if (discountEl) {
      discountEl.textContent = discountValue > 0 ? "−" + formatMoney(discountValue) : formatMoney(0);
    }
    if (totalEl) {
      totalEl.textContent =
        shippingLoaded && shippingCents === null
          ? formatMoney(productTotal)
          : formatMoney(total);
    }
    ctaBtns.forEach(function (btn) {
      btn.disabled = state.loading || items.length < MIN_QTY;
    });
  }

  function loadShippingEstimate() {
    if (!shippingEl) {
      shippingLoaded = true;
      return Promise.resolve();
    }

    var fetchRates =
      typeof window.getShopifyShippingCents === "function"
        ? window.getShopifyShippingCents({
            country: section.getAttribute("data-shipping-country") || "AU",
            province: section.getAttribute("data-shipping-province") || "",
            zip: section.getAttribute("data-shipping-zip") || "",
          })
        : Promise.resolve(null);

    return fetchRates
      .then(function (cents) {
        shippingCents = typeof cents === "number" ? cents : null;
      })
      .catch(function () {
        shippingCents = null;
      })
      .finally(function () {
        shippingLoaded = true;
        updateSidebar();
      });
  }

  function render() {
    updateTabs();
    updateCards();
    updateCategories();
    updateProgress();
    updateSidebar();
  }

  function setTab(tabId) {
    if (!tabId || tabId === state.tab) return;
    state.tab = tabId;
    state.expanded = false;
    render();
  }

  function toggleProduct(id) {
    var product = PRODUCTS[id];
    if (!product || !product.available) return;

    var index = state.selected.indexOf(id);
    if (index !== -1) {
      state.selected.splice(index, 1);
    } else {
      state.selected.push(id);
    }
    render();
  }

  function addBundleToCart() {
    if (state.loading || state.selected.length < MIN_QTY) return;

    var items = state.selected
      .map(function (id) {
        var product = PRODUCTS[id];
        if (!product || !product.variantId) return null;
        return {
          id: parseInt(product.variantId, 10),
          quantity: 1,
        };
      })
      .filter(Boolean);

    if (!items.length) return;

    state.loading = true;
    ctaBtns.forEach(function (btn) {
      btn.disabled = true;
    });

    // Full price — discount is display-only for now
    fetch(CART_URL + (CART_URL.indexOf(".js") !== -1 ? "" : ".js"), {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: items }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error("Cart add failed");
        return res.json();
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent("cart:refresh", { detail: { openDrawer: true } }));
        state.selected = [];
        render();
      })
      .catch(function () {})
      .finally(function () {
        state.loading = false;
        render();
      });
  }

  tabs.forEach(function (btn) {
    btn.addEventListener("click", function () {
      setTab(btn.getAttribute("data-bundle-tab"));
    });
  });

  if (moreBtn) {
    moreBtn.addEventListener("click", function () {
      state.expanded = !state.expanded;
      render();
    });
  }

  if (catalogEl) {
    catalogEl.addEventListener("click", function (event) {
      var toggle = event.target.closest("[data-bundle-toggle]");
      if (!toggle || !catalogEl.contains(toggle)) return;
      event.preventDefault();
      if (toggle.hasAttribute("data-unavailable") || toggle.classList.contains("is-unavailable")) return;
      toggleProduct(toggle.getAttribute("data-bundle-toggle"));
    });

    catalogEl.addEventListener("keydown", function (event) {
      if (event.key !== "Enter" && event.key !== " ") return;
      var toggle = event.target.closest("[data-bundle-toggle]");
      if (!toggle || !catalogEl.contains(toggle)) return;
      event.preventDefault();
      if (toggle.hasAttribute("data-unavailable") || toggle.classList.contains("is-unavailable")) return;
      toggleProduct(toggle.getAttribute("data-bundle-toggle"));
    });
  }

  ctaBtns.forEach(function (btn) {
    btn.addEventListener("click", function (event) {
      event.preventDefault();
      addBundleToCart();
    });
  });

  // Keep the mobile card under the sticky header.
  var header = document.querySelector("[data-header]");
  function setStickyTop() {
    var top = header ? Math.round(header.getBoundingClientRect().height) : 0;
    section.style.setProperty("--bundle-sticky-top", top + "px");
  }
  setStickyTop();
  window.addEventListener("resize", setStickyTop);

  render();
  loadShippingEstimate();
})();
